export const FETCH_TEMPLATES = 'FETCH_TEMPLATES';
export const CREATE_TEMPLATE = 'CREATE_TEMPLATE';
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE';
export const REMOVE_TEMPLATE = 'REMOVE_TEMPLATE';

